/**
 * InDeep-Net
 * Copyright (C) 2025
 * Authors: Fabien MAREUIL
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 */
export function ChoicesButton(props) {

    return(
        <button
            id={props.value}
            type="button"
            className={`px-2 min-w-full min-h-full rounded-xl border-2 border-sky-950 shadow-md shadow-stone-800 dark:shadow-stone-200 ${props.selected === props.value ? ' bg-stone-400 shadow-none': 'bg-gray-100 hover:bg-gray-400 text-gray-800'}`}
            onClick={() => props.handle(props.value)}
        >
        <div className="flex flex-col h-full py-6 items-center">
        { props.src && <img className="h-8 m-2" src={ props.src } alt="logo"></img>
            }
        <div className="text-sky-950">
            <h4 className={ `font-bold text-xl` }>{ props.label }</h4>
            <small>{ props.description }</small>
        </div>
        </div>
        </button>
        
    )
}

export function LittleChoicesButton(props) {
    return(
        <button
            id={props.id}
            type="button"
            className={`px-2 min-w-full h-10 rounded-xl border-2 border-gray-800 shadow-md shadow-stone-800 dark:shadow-stone-200 ${props.selected === props.value ? 'bg-sky-950 text-white shadow-none': 'bg-gray-100 hover:bg-gray-400 text-gray-800'}`}
            onClick={() => props.handle(props.value)}
        >
        <div>
            <h4 className={ `font-bold text-xs` }>{ props.label }</h4>
            {props.description && <small>{ props.description }</small>}
        </div>
        </button>
        
    )
}

